import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrSlotStatus.ts
var t = () => e("slotStatus");
//#endregion
export { t as useTrSlotStatus };
